module.exports = __webpack_public_path__ + "images/emoji/abcd.a0215b6768042d42c1ba.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/abcd.png
// module id = atkG
// module chunks = 1